import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div`
    margin-top: ${theme.space[3]}px;
`;

export const HeaderTitle = styled.div`
    padding-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 10%;
    line-height: 1.89rem;
    color: ${theme.colors.midnight};
    border-bottom: 1px solid ${theme.colors.silver};
`;

export const Panel = styled.div`
    margin-top: ${theme.space[3]}px;
`;

export const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 0 ${theme.space[3]}px 0;
`;

export const Title = styled.div``;

export const PriceWrapper = styled.div``;

export const Content = styled.div`
    width: 100%;
    padding: 0;
`;
